import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';

export const RateCardBasicInfoComponent = ({ accountsList, accountListLoading, accountTypesList, accountTypesListLoading, policyOwnerTypes, policyOwnerTypesListLoading, onInnerBasicFormChange, selectedRateCards, shippingProviders }: any) => {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'Name'
                )
              }}
              type="text"
              value={selectedRateCards?.Name}
            />
            <InputContainer
              label="Level"
              labelField="Text"
              isLoading={policyOwnerTypesListLoading}
              list={policyOwnerTypes}
              isDisabled={selectedRateCards?.Id && selectedRateCards?.OwnerId}
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'OwnerId'
                );
              }}
              optionName='Choose Level'
              type="select"
              value={selectedRateCards?.OwnerId}
              valueField="Value"
            />
            <InputContainer
              label="Account Type"
              labelField="Name"
              isLoading={accountTypesListLoading}
              list={accountTypesList}
              isDisabled={selectedRateCards?.Id && selectedRateCards?.AssociatedAccountTypeId}
              onValueChange={(event: any, newValue: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'AssociatedAccountTypeId',
                );
              }}
              optionName='Choose Account Type'
              type="select"
              value={selectedRateCards?.AssociatedAccountTypeId}
              valueField="Id"
            />
            <InputContainer
              label="Account Name"
              labelField="Name"
              isLoading={accountListLoading}
              list={accountsList}
              isDisabled={selectedRateCards?.Id && selectedRateCards?.AssociatedAccountId}
              onValueChange={(event: any, newValue: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'AssociatedAccountId',
                );
              }}
              optionName='Choose Account Name'
              type="select"
              value={selectedRateCards?.AssociatedAccountId}
              valueField="Id"
            />


            <InputContainer
              label="Always Enabled"
              name="IsAlwaysEnabled"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event,
                  'IsAlwaysEnabled'
                )
              }}
              type="checkbox"
              value={selectedRateCards?.IsAlwaysEnabled}
            />

            {!selectedRateCards?.IsAlwaysEnabled ? <>
              <InputContainer
                label="Start Date"
                name="StartDateUtc"
                onValueChange={(event: any) => {
                  onInnerBasicFormChange(
                    event.target.value,
                    'StartDateUtc'
                  )
                }}
                type="date"
                value={selectedRateCards?.StartDateUtc}
              />
              <InputContainer
                label="End Date"
                name="EndDateUtc"
                onValueChange={(event: any) => {
                  onInnerBasicFormChange(
                    event.target.value,
                    'EndDateUtc'
                  )
                }}
                type="date"
                value={selectedRateCards?.EndDateUtc}
              />
            </> : <></>}
            <InputContainer

              label="Display Order"
              name="DisplayOrder"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'DisplayOrder'
                )
              }}
              type="number"
              value={selectedRateCards?.DisplayOrder}
            />
            <InputContainer
              label="Active"
              name="IsActive"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event,
                  'IsActive'
                )
              }}
              type="checkbox"
              value={selectedRateCards?.IsActive}
            />

            <div className='col-span-full'>
              <InputContainer
                label="Description"
                name="Description"
                onValueChange={(event: any) => {
                  onInnerBasicFormChange(
                    event.target.value,
                    'Description'
                  )
                }}
                type="text"
                value={selectedRateCards?.Description}
              />

            </div>
          </div>
        }
        expandedPanel="BasicInfo"
        headerTitle="Basic Info"
      />


    </>

  )
}
export default RateCardBasicInfoComponent;
